import React from 'react';
import _ from 'lodash';
import { getTotalHeaderHeight } from 'Utils';

/** Check if mc-connect header, navbar, subnav bar exists and calculate the proper
 * sticky positioning for table head. Need to check for window resize as
 * table headers change height to fit the text */
const useStickyTableHead = (tableId: string) => {
    React.useEffect(() => {
        function handleStickyPos() {
            if (tableId) {
                const totalHeight = getTotalHeaderHeight();
                const tableElement = document.querySelector(`[data-testid="${tableId}"]`);

                // set table's thead into sticky
                const theadElement = tableElement?.getElementsByClassName('thead');
                if (theadElement && theadElement[0]) {
                    (theadElement[0] as HTMLDivElement).style.position = 'sticky';
                    (theadElement[0] as HTMLDivElement).style.top = `${totalHeight}px`;
                }

                // set groupby headers into sticky if there is one
                const groupByHeaderElements = tableElement?.querySelectorAll('[data-isgrouped="true"]');
                if (groupByHeaderElements) {
                    const tableHeadHeight = (theadElement && (theadElement[0] as HTMLDivElement)?.offsetHeight) ?? 0;
                    groupByHeaderElements.forEach((rowGroup) => {
                        (rowGroup as HTMLDivElement).style.position = 'sticky';
                        (rowGroup as HTMLDivElement).style.top = `${totalHeight + tableHeadHeight}px`;
                    });
                }
            }
        }

        // need to call first time
        handleStickyPos();

        const throttledResizing = _.throttle(handleStickyPos, 300);

        window.addEventListener('resize', throttledResizing);

        return () => window.removeEventListener('resize', throttledResizing);
    }, [tableId]);
};

export default useStickyTableHead;
